export const CUSTOM_AUTOMATION_ACTIONS = {
  CANCEl: 'cancel_automation',
  PAUSE: 'pause_automation',
  START: 'start_automation',
  START_AND_RESUME: 'start_and_resume_automation',
};
